
AddPageSwapTrigger(function() {
    $('.on_subscribe_open_coupon').unbind('click');
    $('.on_subscribe_open_coupon').click(function () {
        if ($('#nieuwsbrief_target').is('#nieuwsbrief_target')) {
            $('#modalNieuwsbrief .customfield_451').val($('#nieuwsbrief_target').val());
        }
        SubscribeOpenCoupon();
    });

    if ($.cookie('nieuwsbrief_subscribed1') == 1) {
        nieuwsbriefSubscribed();
    }
    else {
        $('.if_nieuwsbrief_not_subscribed_show').show();
        $('.if_nieuwsbrief_subscribed').hide();
    }
});